import useTranslate from "../../core/languages/hooks/useTranslate";
import BookingItem from "../types/BookingItem";
import React from "react";
import Hotel from "../../hotels/types/Hotel";
import BookingItemCard from "./BookingItemCard";

const RoomDetailsCard: React.FC<{bookingItems: BookingItem[]; hotelInfo: Hotel; currencySymbol: string}> = ({bookingItems, hotelInfo, currencySymbol}) => {
    const t = useTranslate();

    const renderItem = (data: BookingItem, hotel: Hotel, currencySymbol: string) => (
        <div className="w-full flex flex-col sm:rounded-2xl lg:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8 mb-4" key={data.id}>
            <BookingItemCard item={data} hotel={hotel} currencySymbol={currencySymbol}/>
        </div>
    );

    return (
        <div>
            <h3 className="text-3xl lg:text-2xl font-semibold mb-2 text-neutral-900 dark:text-neutral-100">
                {t("bookOk.roomDetails")}
            </h3>
            <p className="text-sm text-neutral-500 dark:text-neutral-400 mb-6">
                {t("bookOk.roomDetailsSubtitle")}
            </p>
            {bookingItems.map((item: BookingItem) => renderItem(item, hotelInfo, currencySymbol))}
        </div>
    );
};

export default RoomDetailsCard;
